import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "content title"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [/*#__PURE__*/_createElementVNode("tr", null, [/*#__PURE__*/_createElementVNode("th", {
  style: {
    "font-size": "12px",
    "padding": "0 10px"
  }
}, "机构"), /*#__PURE__*/_createElementVNode("th", {
  style: {
    "font-size": "12px",
    "padding": "0 10px"
  }
}, "让球"), /*#__PURE__*/_createElementVNode("th", {
  style: {
    "font-size": "12px",
    "padding": "0 10px"
  }
}, "胜"), /*#__PURE__*/_createElementVNode("th", {
  style: {
    "font-size": "12px",
    "padding": "0 10px"
  }
}, "平"), /*#__PURE__*/_createElementVNode("th", {
  style: {
    "font-size": "12px",
    "padding": "0 10px"
  }
}, "负"), /*#__PURE__*/_createElementVNode("th", {
  style: {
    "font-size": "12px",
    "padding": "0 10px"
  }
}, "胜率"), /*#__PURE__*/_createElementVNode("th", {
  style: {
    "font-size": "12px",
    "padding": "0 10px"
  }
}, "平率"), /*#__PURE__*/_createElementVNode("th", {
  style: {
    "font-size": "12px",
    "padding": "0 10px"
  }
}, "负率")])], -1);
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  style: {
    "font-size": "12px",
    "padding": "0 8px"
  }
};
const _hoisted_5 = {
  style: {
    "font-size": "12px",
    "padding": "0 8px"
  }
};
const _hoisted_6 = {
  style: {
    "font-size": "12px",
    "padding": "0 8px"
  }
};
const _hoisted_7 = {
  style: {
    "font-size": "12px",
    "padding": "0 8px"
  }
};
const _hoisted_8 = {
  style: {
    "font-size": "12px",
    "padding": "0 8px"
  }
};
const _hoisted_9 = {
  style: {
    "font-size": "12px",
    "padding": "0 8px"
  }
};
const _hoisted_10 = {
  style: {
    "font-size": "12px",
    "padding": "0 8px"
  }
};
const _hoisted_11 = {
  style: {
    "font-size": "12px",
    "padding": "0 8px"
  }
};
const _hoisted_12 = {
  key: 1
};
const _hoisted_13 = {
  style: {
    "font-size": "12px",
    "padding": "0 8px"
  }
};
const _hoisted_14 = {
  style: {
    "font-size": "12px",
    "padding": "0 8px"
  }
};
const _hoisted_15 = {
  style: {
    "font-size": "12px",
    "padding": "0 8px"
  }
};
const _hoisted_16 = {
  style: {
    "font-size": "12px",
    "padding": "0 8px"
  }
};
const _hoisted_17 = {
  style: {
    "font-size": "12px",
    "padding": "0 8px"
  }
};
import { ref } from 'vue';
import { showNotify } from '@nutui/nutui';
import axios from 'axios';
import * as echarts from 'echarts';
export default {
  __name: 'BeiDanViewCompare',
  setup(__props, {
    expose: __expose
  }) {
    const timeNotify = msg => {
      showNotify.warn(msg, {
        duration: 2000
      });
    };
    const chartContainer1 = ref(null);
    const chartContainer2 = ref(null);
    const chartContainer3 = ref(null);
    const chartContainer4 = ref(null);
    const title = ref('');
    const isListVisible = ref(false);
    const active = ref(0);
    const oddsList = ref([{
      "sp1": "",
      "sp2": "",
      "sp3": ""
    }]);
    const loading = ref(false);
    const id = ref("");
    const item = ref({});
    // 显示弹出框
    const show = (matchId, match) => {
      isListVisible.value = true;
      item.value = match;
      id.value = matchId;
      active.value = 0;
      title.value = match.homeTeamAbbName + ' VS ' + match.awayTeamAbbName;
      if (match.sectionsNo999 != '') {
        title.value = match.homeTeamAbbName + ' ' + match.sectionsNo999 + ' ' + match.awayTeamAbbName;
      }
      oddsList.value = [[{
        "sp1": "",
        "sp2": "",
        "sp3": ""
      }]];
      getOdds(matchId);
    };

    // 关闭弹出框
    const close = () => {
      isVisible.value = false;
    };
    const styleColor = (val1, val2) => {
      if (Number(val1) > Number(val2)) {
        return "color:red";
      } else if (Number(val1) < Number(val2)) {
        return "color:green";
      } else {
        return "";
      }
    };
    const getTime = time => {
      // 将字符串转换为Date对象
      const date = new Date(time);
      const day = date.getDay();
      // 提取小时和分钟
      const hours = date.getHours(); // 获取小时数 (0-23)
      const minutes = date.getMinutes(); // 获取分钟数 (0-59)
      return day + " " + (hours > 9 ? hours : "0" + hours) + ":" + (minutes > 9 ? minutes : "0" + minutes);
    };
    const getOdds = async matchId => {
      loading.value = true;
      const response = await axios.get('https://tuhaojie.asia/api-foot/beijing/getMatchRate?matchId=' + matchId);
      //const response = await axios.post('http://127.0.0.1:8888/beijing/selectBeiJin?matchId=' + matchId);
      let data = response.data;
      const response1 = await axios.post('https://tuhaojie.asia/api-foot/beijing/selectBeiJin11?matchId=' + matchId);
      let data1 = response1.data;
      let beidan = [];
      let zhuren = [];
      let zhichi = [];
      let hp = 0;
      if (data1.length > 0) {
        const chart = echarts.init(chartContainer1.value);
        let time = [];
        let h = [];
        let d = [];
        let a = [];
        for (let i = data1.length - 1; i >= 0; i--) {
          let item = data1[i];
          time.push(getTime(item.createTime));
          h.push(item.sp1Rate);
          d.push(item.sp2Rate);
          a.push(item.sp3Rate);
          hp = item.handicap;
          if (i == 0) {
            beidan.push(item.sp3Rate);
            beidan.push(item.sp2Rate);
            beidan.push(item.sp1Rate);
          }
        }
        let option = {
          xAxis: {
            type: 'category',
            data: time
          },
          legend: {
            data: ['胜', '平', '负']
          },
          yAxis: {
            type: 'value'
          },
          grid: {
            left: '10%',
            right: '3%',
            bottom: '8%'
          },
          series: [{
            name: "胜",
            data: h,
            type: 'line',
            smooth: true
          }, {
            name: "平",
            data: d,
            type: 'line',
            smooth: true
          }, {
            name: "负",
            data: a,
            type: 'line',
            smooth: true
          }]
        };
        chart.setOption(option);
      }
      let responseApi = await axios.get('https://tuhaojie.asia/api-foot/supportRateV1/getRate?matchId=' + matchId);
      let data2 = responseApi.data;
      if (data2.length > 0) {
        const chart = echarts.init(chartContainer2.value);
        const chart3 = echarts.init(chartContainer3.value);
        let time = [];
        let h = [];
        let d = [];
        let a = [];
        let hh = [];
        let hd = [];
        let ha = [];
        for (let i = 0; i < data2.length; i++) {
          let item = data2[i];
          time.push(item.dateString);
          h.push(Number(item.hsupportRate.replace('%', '')));
          d.push(Number(item.dsupportRate.replace('%', '')));
          a.push(Number(item.asupportRate.replace('%', '')));
          hh.push(Number(item.hhsupportRate.replace('%', '')));
          hd.push(Number(item.dhsupportRate.replace('%', '')));
          ha.push(Number(item.ahsupportRate.replace('%', '')));
          if (i == data2.length - 1) {
            if (hp == '0') {
              zhuren.push(Number(item.hadARate.replace('%', '')));
              zhuren.push(Number(item.hadDRate.replace('%', '')));
              zhuren.push(Number(item.hadHRate.replace('%', '')));
              zhichi.push(Number(item.asupportRate.replace('%', '')));
              zhichi.push(Number(item.dsupportRate.replace('%', '')));
              zhichi.push(Number(item.hsupportRate.replace('%', '')));
            } else {
              zhuren.push(Number(item.hhadARate.replace('%', '')));
              zhuren.push(Number(item.hhadDRate.replace('%', '')));
              zhuren.push(Number(item.hhadHRate.replace('%', '')));
              zhichi.push(Number(item.ahsupportRate.replace('%', '')));
              zhichi.push(Number(item.dhsupportRate.replace('%', '')));
              zhichi.push(Number(item.hhsupportRate.replace('%', '')));
            }
          }
        }
        let option = {
          xAxis: {
            type: 'category',
            data: time
          },
          legend: {
            data: ['胜', '平', '负']
          },
          yAxis: {
            type: 'value'
          },
          grid: {
            left: '10%',
            right: '3%',
            bottom: '8%'
          },
          series: [{
            name: "胜",
            data: h,
            type: 'line',
            smooth: true
          }, {
            name: "平",
            data: d,
            type: 'line',
            smooth: true
          }, {
            name: "负",
            data: a,
            type: 'line',
            smooth: true
          }]
        };
        let option1 = {
          xAxis: {
            type: 'category',
            data: time
          },
          legend: {
            data: ['让胜', '让平', '让负']
          },
          yAxis: {
            type: 'value'
          },
          grid: {
            left: '10%',
            right: '3%',
            bottom: '8%'
          },
          series: [{
            name: "让胜",
            data: hh,
            type: 'line',
            smooth: true
          }, {
            name: "让平",
            data: hd,
            type: 'line',
            smooth: true
          }, {
            name: "让负",
            data: ha,
            type: 'line',
            smooth: true
          }]
        };
        chart.setOption(option);
        chart3.setOption(option1);
      }
      const chart4 = echarts.init(chartContainer4.value);
      let option2 = {
        title: {
          text: '对比'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01]
        },
        yAxis: {
          type: 'category',
          data: ['负', '平', '胜']
        },
        series: [{
          name: '北单',
          type: 'bar',
          data: beidan
        }, {
          name: '主任',
          type: 'bar',
          data: zhuren
        }, {
          name: '支持',
          type: 'bar',
          data: zhichi
        }]
      };
      chart4.setOption(option2);
      oddsList.value = data;
      loading.value = false;
    };

    // 暴露给外部使用的函数
    __expose({
      show,
      close
    });
    return (_ctx, _cache) => {
      const _component_nut_col = _resolveComponent("nut-col");
      const _component_nut_row = _resolveComponent("nut-row");
      const _component_var_table = _resolveComponent("var-table");
      const _component_var_loading = _resolveComponent("var-loading");
      const _component_var_col = _resolveComponent("var-col");
      const _component_var_row = _resolveComponent("var-row");
      const _component_nut_popup = _resolveComponent("nut-popup");
      return _openBlock(), _createBlock(_component_nut_popup, {
        visible: isListVisible.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = $event => isListVisible.value = $event),
        closeable: "",
        style: {
          padding: '30px 10px',
          height: '85%',
          width: '90%',
          overflow: 'auto'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_nut_row, null, {
          default: _withCtx(() => [_createVNode(_component_nut_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString(title.value), 1)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_var_row, null, {
          default: _withCtx(() => [_createVNode(_component_var_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_var_row, null, {
              default: _withCtx(() => [_createVNode(_component_var_col, {
                span: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_var_loading, {
                  description: "加载中",
                  loading: loading.value
                }, {
                  default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_var_table, {
                    "scroller-height": "250",
                    "full-width": "80%"
                  }, {
                    default: _withCtx(() => [_hoisted_2, _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(oddsList.value, (item, index) => {
                      return _openBlock(), _createElementBlock(_Fragment, {
                        key: index
                      }, [index == oddsList.value.length - 1 ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [_createElementVNode("td", _hoisted_4, _toDisplayString(item.name), 1), _createElementVNode("td", _hoisted_5, _toDisplayString(item.handicap), 1), _createElementVNode("td", _hoisted_6, _toDisplayString(item.sp1), 1), _createElementVNode("td", _hoisted_7, _toDisplayString(item.sp2), 1), _createElementVNode("td", _hoisted_8, _toDisplayString(item.sp3), 1), _createElementVNode("td", _hoisted_9, _toDisplayString(item.sp1Rate), 1), _createElementVNode("td", _hoisted_10, _toDisplayString(item.sp2Rate), 1), _createElementVNode("td", _hoisted_11, _toDisplayString(item.sp3Rate), 1)])) : (_openBlock(), _createElementBlock("tr", _hoisted_12, [_createElementVNode("td", _hoisted_13, _toDisplayString(item.name), 1), _createElementVNode("td", _hoisted_14, _toDisplayString(item.handicap), 1), _createElementVNode("td", {
                        style: _normalizeStyle([{
                          "font-size": "12px",
                          "padding": "0 8px"
                        }, styleColor(item.sp1, oddsList.value[index + 1].sp1)])
                      }, _toDisplayString(item.sp1), 5), _createElementVNode("td", {
                        style: _normalizeStyle([{
                          "font-size": "12px",
                          "padding": "0 8px"
                        }, styleColor(item.sp2, oddsList.value[index + 1].sp2)])
                      }, _toDisplayString(item.sp2), 5), _createElementVNode("td", {
                        style: _normalizeStyle([{
                          "font-size": "12px",
                          "padding": "0 8px"
                        }, styleColor(item.sp3, oddsList.value[index + 1].sp3)])
                      }, _toDisplayString(item.sp3), 5), _createElementVNode("td", _hoisted_15, _toDisplayString(item.sp1Rate), 1), _createElementVNode("td", _hoisted_16, _toDisplayString(item.sp2Rate), 1), _createElementVNode("td", _hoisted_17, _toDisplayString(item.sp3Rate), 1)]))], 64);
                    }), 128))])]),
                    _: 1
                  })])]),
                  _: 1
                }, 8, ["loading"])]),
                _: 1
              })]),
              _: 1
            })])]),
            _: 1
          }), _createVNode(_component_var_col, null, {
            default: _withCtx(() => [_createElementVNode("div", {
              ref_key: "chartContainer1",
              ref: chartContainer1,
              style: {
                "width": "90vw",
                "height": "300px"
              }
            }, null, 512)]),
            _: 1
          }), _createVNode(_component_var_col, null, {
            default: _withCtx(() => [_createElementVNode("div", {
              ref_key: "chartContainer2",
              ref: chartContainer2,
              style: {
                "width": "90vw",
                "height": "300px"
              }
            }, null, 512)]),
            _: 1
          }), _createVNode(_component_var_col, null, {
            default: _withCtx(() => [_createElementVNode("div", {
              ref_key: "chartContainer3",
              ref: chartContainer3,
              style: {
                "width": "90vw",
                "height": "300px"
              }
            }, null, 512)]),
            _: 1
          }), _createVNode(_component_var_col, null, {
            default: _withCtx(() => [_createElementVNode("div", {
              ref_key: "chartContainer4",
              ref: chartContainer4,
              style: {
                "width": "90vw",
                "height": "400px"
              }
            }, null, 512)]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["visible"]);
    };
  }
};